import DataTable from 'components/Core/DataTable';
import PurchaseOrder from 'lib/Core/Backend/Controllers/PurchaseOrder';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactNotificationAlert from 'react-notification-alert';
import Notify from "../../lib/Utils/Alert";
import { Alert, Col, Row, Progress, ModalHeader, ModalBody,  Button, ModalFooter, Modal} from 'reactstrap';
import Utils from 'lib/Utils/Utils';
const calculateSubTotal = (amount, quantity, fees, discount) => {
  return ((amount * quantity) - ((amount * quantity) * (discount / 100))) + (quantity * fees);
}
const OrderDetails = (props) => {
  const { order, token, brands, cardTypes, name, OrderName, show,progressName,checkOrder, progressShow,openDrawer } = props;
  const [pogressValue, setPogressValue] = useState(null)
  const [detailsData,setDetailsData] = useState([])
  const poCtl = useMemo(() => new PurchaseOrder(token), [token]);
  const purchaseOrderCtl = useMemo(() => new PurchaseOrder(token), [token]);
  const [warningModal,setWarningModal] = useState(false);
	const toggleWarning = () => setWarningModal(!warningModal);
  const dollar = useMemo(() => Intl.NumberFormat('en-US', {
    style: "currency",
    currency: "USD",
  }), []);
  const table = useRef();
  const alert = useRef();
  const [total, setTotal] = useState('')
  const [loading,setLoading] = useState(true)
  const headers = [
    { title: 'Brand', data: 'brandName', searchable: true, sortable: true },
    { title: 'Card Type', data: 'cardType', searchable: true, sortable: true },
    { title: 'SKU', data: 'sku', searchable: true, sortable: true },
    { title: 'Currency', data: 'currency', searchable: true, sortable: true },
    { title: 'Fee', data: 'fee', searchable: true, sortable: true },
    { title: 'Discount', data: 'discount', searchable: true, sortable: true, render: data => data ? Utils.percentFormat(data / 100) : '0.00%' },
    { title: 'Qty', data: 'quantity', searchable: true, sortable: true },
    { title: 'Value', data: 'amount', sortable: true, render: data => data ? dollar.format(data) : 0 },
    { title: 'Subtotal', data: 'subtotal', sortable: true, render: data => data ? dollar.format(data) : 0 },
    { title: 'Profit', data: 'profit', sortable: true, render: data => data ? dollar.format(data) : 0 },
    { title: 'Margin Percentage', data: 'marginPercentage', searchable: true, sortable: true, render: data => data ? Utils.percentFormat(data / 100) : '0.00%' }
  ]
 
  
  
  const onDraw = () => {
    if (table.current) {
      if (table.current.dataTable.rows().data()) {
        let total = table.current.dataTable.rows().data()
          .reduce((a, b) => {
            return a + b.subtotal;
          }, 0);

        setTotal(dollar.format(total));
      } else {
        setTotal('$0.00');
      }
    }
  }

  const progressFunc = () => {
  
 if(name){
  if(OrderName?.includes("NRT")){
    purchaseOrderCtl.getPogress(name, (data) => {
      if (data && !data.error) {
        setPogressValue(data[0].percentage)
      }
      else {
        Notify(alert, "danger", data.error)
      }
    })
  }else{
    purchaseOrderCtl.getProgressAPI(name,(data)=>{
      if (data && !data.error) {
        setPogressValue(data[0].percentage)
      }
      else {
        Notify(alert, "danger", data.error)
      }

    })
  }
}
    
  }

  const progressBar = () =>{
    if(order){
      if(checkOrder?.includes("NRT")){
        purchaseOrderCtl.getPogress(order?.name, (data) => {
          if (data && !data.error) {
            setPogressValue(data[0].percentage)
          }
          else {
            Notify(alert, "danger", data.error)
          }
        })
      }else{
        if(order?.id){
          purchaseOrderCtl.getProgressAPI(order?.id,(data)=>{
            if (data && !data.error) {
              setPogressValue(data[0].percentage)
            }
            else {
              Notify(alert, "danger", data.error)
            }
    
          })
        }
        
      }
    }
    
 }

  const fetchData = () => {
    setLoading(true)
    poCtl.purchaseOrderDetailAdmin(order?.id, data => {
      if (data?.status === 403) {
        toggleWarning();
        setLoading(false)
        return;
      }
      if (data.error || data.errorMessage) {
        if (data?.error !== 'Server error response code: 400. Unable to parse response body.') {
          Notify(alert, 'danger', data.errorMessage ?? data.error);
          setLoading(false)
        }
      } else {
        const orderDetails = data.map(detail => {
          const currencyFormat = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: order?.currency ?? 'USD'
          });
          const card = cardTypes.find(card => card.id === detail.cardTypeId);
          return {
            ...detail,
            brandName: brands.find(brand => brand.id === detail.brandId).name,
            cardType: card ? card.productName : 'Not Available',
            sku: card ? card.sku : 'Not Available',
            subtotal: calculateSubTotal(detail.amount, detail.quantity, detail.fee, detail.discount),
            currency: order.currency,
            fee: currencyFormat.format(detail.fee)
          };
        });
        setLoading(false)
        setDetailsData(orderDetails);
        table.current.dataTable.clear().rows.add(orderDetails).draw();
      }
    });
  };

  useEffect(()=>{
    progressBar()
  },[progressShow])

  useEffect(() => {
    if (openDrawer) {
      fetchData();
    } else if (table.current) {
      table.current.dataTable.clear().draw();
      setPogressValue(null)
    }
  }, [openDrawer, poCtl, order, brands, cardTypes]);
  useEffect(() => {
    progressFunc()
  }, [show])
  return (
    <>
      <ReactNotificationAlert ref={alert} />
      <Row className='justify-content-between m-4'>
        <Col>
          <div>
            <h4>Summary...</h4>
            {/* <DataTable
              options={{
                paging: false,
                searching: false,
                responsive: true,
                info: false,
                saveState: true,
                drawCallback: onDraw,
              }}
              ref={table}
              data={null}
              columns={headers}
            /> */}

          <div className='table-responsive'>
          <table class="table purchaser_class table dataTable no-footer order_details_table">
            <thead>
              <tr>
                
                <th>Brand</th>
                <th>Card Type</th>
                <th>SKU</th>
                <th>Currency</th>
                <th>Fee</th>
                <th>Discount</th>
                <th>Qty</th>
                <th>Value</th>
                <th>Subtotal</th>
                <th>Profit</th>
                <th>Margin Percentage</th>

              </tr>
            </thead>
            <tbody>
            {loading ? (
            <tr>
              <td colSpan="10" className="">
              <div className='d-flex justify-content-center align-items-center flex-column vh-50'>
								   <div className="spinner-border text-muted text-center"></div>
								</div>
              </td>
            </tr>
          ) : detailsData.length > 0 ? (
            detailsData.map((item, index) => {
              return (
                <tr key={index}>
                
                <td>{item?.brandName}</td>
                <td>{item?.cardType}</td>
                <td>{item?.sku}</td> 
                <td>{item?.currency}</td>
                <td>{item?.fee}</td>
                <td>{item?.discount}</td>
                <td>{item?.quantity}</td>
                <td>{item?.amount}</td>
                <td>{item?.subtotal}</td>
                <td>{item?.profit}</td>
                <td>{item?.marginPercentage}</td>
            </tr>
              )
             
            })
          ) : (
            <tr>
              <td colSpan="10" className="text-center">
                No data available
              </td>
            </tr>
          )}
            </tbody>
          </table>
          </div>
        

          </div>
        </Col>
      </Row>
      <Progress
        className="my-2 mx-5"
        value={pogressValue}
      >
        {pogressValue}%
      </Progress>
      <Row className='justify-content-end m-5'>
        <Col sm='4' className='mr-4'>
          <Alert color='success'>
            <Row className='justify-content-between'>
              <Col sm='3'>Total</Col>
              <Col sm='9'><p className='p-0 m-0 text-right'>{total}</p></Col>
            </Row>
          </Alert>
        </Col>
      </Row>
      <Modal isOpen={warningModal} toggle={toggleWarning} backdrop="static">
            <ModalHeader className="bg-warning" toggle={toggleWarning}>Access Denied</ModalHeader>
            <ModalBody>
                <p className="card-just-text">
				You do not have access to perform this action
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggleWarning}>Close</Button>
            </ModalFooter>
         </Modal>
    </>
  );
}

export default OrderDetails;